import { Component } from '@angular/core';

import {NavController, NavParams} from 'ionic-angular';


import {UserData} from "../../../../providers/user-data";
import {MissionsContractListPage} from "../../missions-contract/missions-contract-list/missions-contract-list";
import {MissionsCandidatePage} from "../mission-candidate-list/missions-candidate";
import {MissionsCalendarPage} from "../missions-calendar/missions-calendar";
import {MessagingPage} from "../../../account/messaging/messaging";
import {NotificationsPage} from "../../../account/notifications/notifications";


@Component({
  templateUrl: 'tabs.html',
  selector: 'tabs',
})
export class MissionsTabsPage {
  // set the root pages for each tab
  tab1Root: any = NotificationsPage;
  tab2Root: any = MessagingPage;
  tab3Root: any = MissionsCandidatePage;
  tab4Root: any = MissionsCalendarPage;


  mySelectedIndex: number;

  constructor(
      navParams: NavParams,
      public navCtrl: NavController,
      public user: UserData
  ) {
    this.mySelectedIndex = navParams.data.tabIndex || 0;
  }
  ionViewWillEnter() {
    //this.user.checkLoggedIn(this.navCtrl,'SchedulePage');
  }
}



// WEBPACK FOOTER //
// ./src/pages/missions/missions-candidate/tabs/tabs.ts